import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { setUserPassword, setUserEmail, setUserUsername, getFullProfileInfo, setUserProfiePicture } from '../../api/userManagement.js';
import './index.css'

class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            userEmail: '',
            userUID: '',
            userPictureURL: '',
            userLoginMethod: 'password',
            newpassword: '',
            rnewpassword: '',
            newpasswordpassword: '',
            newemail: '',
            newemailpassword: '',
            newusername: '',
            newusernamepassword: '',
            ChangePictureStatusText: '',
            ChangeUsernameStatusText: '',
            ChangePasswordStatusText: '',
            ChangeEmailStatusText: ''
        };
        this.fileInput = React.createRef();
        this.distanceBeetweenFields = 'ooooooo';
    }

    componentDidMount() {
        getFullProfileInfo(this);
    }

    handleChange = (event) => {
        const name = event.target.name;
        this.setState({ [name]: event.target.value });
    }

    handleUserPictureChangeSubmit = (event) => {
        event.preventDefault();
        if (this.fileInput.current.files[0]) {
            setUserProfiePicture(this.fileInput.current.files[0], this.state.userUID, this);
        }
    }

    handleEmailChangeSubmit = (event) => {
        event.preventDefault();
        setUserEmail(this.state.newemail, this.state.newemailpassword, this);
    }

    handleUsernameChangeSubmit = (event) => {
        event.preventDefault();
        setUserUsername(this.state.newusername, this.state.newusernamepassword, this);
    }

    handlePasswordChangeSubmit = (event) => {
        event.preventDefault();
        setUserPassword(this.state.newpassword, this.state.rnewpassword, this.state.newpasswordpassword, this);
    }

    render() {
        let userSettings;
        if (this.state.userLoginMethod === 'password') userSettings =
            <div id="UserSettings">
                <form id="TextForm" onSubmit={this.handleUsernameChangeSubmit}>
                    <h2 id="ActionTitle">Change username:</h2>
                    <TextField
                        label="New username"
                        name="newusername"
                        type="login"
                        value={this.state.newusername}
                        margin="normal"
                        onChange={this.handleChange}
                    />
                    <TextField
                        label="Password"
                        name="newusernamepassword"
                        type="password"
                        value={this.state.newusernamepassword}
                        margin="normal"
                        onChange={this.handleChange}
                    />
                    <div id="ButtonContainer">
                        <Button variant="contained" type="submit" id="SubmitButton">submit</Button>
                    </div>
                    <p>{this.state.ChangeUsernameStatusText}</p>
                </form>
                <br /><br />
                <form id="TextForm" onSubmit={this.handleEmailChangeSubmit}>
                    <h2 id="ActionTitle">Change email:</h2>
                    <TextField
                        label="New email"
                        name="newemail"
                        type="login"
                        value={this.state.newemail}
                        margin="normal"
                        textAlign="center"
                        onChange={this.handleChange}
                    />
                    <TextField
                        label="Password"
                        name="newemailpassword"
                        type="password"
                        value={this.state.newemailpassword}
                        margin="normal"
                        onChange={this.handleChange}
                    />
                    <div id="ButtonContainer">
                        <Button variant="contained" type="submit" id="SubmitButton">submit</Button>
                    </div>
                    <p>{this.state.ChangeEmailStatusText}</p>
                </form>
                <br /><br />
                <form id="TextForm" onSubmit={this.handlePasswordChangeSubmit}>
                    <h2 id="ActionTitle">Change password:</h2>
                    <TextField
                        label="New password"
                        name="newpassword"
                        type="password"
                        value={this.state.newpassword}
                        margin="normal"
                        onChange={this.handleChange}
                    />
                    <TextField
                        label="Repeat new password"
                        name="rnewpassword"
                        type="password"
                        value={this.state.rnewpassword}
                        margin="normal"
                        onChange={this.handleChange}
                    />
                    <TextField
                        label="Old password"
                        name="newpasswordpassword"
                        type="password"
                        value={this.state.newpasswordpassword}
                        margin="normal"
                        onChange={this.handleChange}
                    />
                    <div id="ButtonContainer">
                        <Button variant="contained" type="submit" id="SubmitButton">submit</Button>
                    </div>
                    <p>{this.state.ChangePasswordStatusText}</p>
                </form>
            </div>
        else userSettings = null;
        return (
            <div>
                <div id="ProfilePicture">
                    <div id="profilePictureDisplay">
                        <img src={this.state.userPictureURL} height="150px" width="150px" alt="" />
                    </div>
                    <span id="invisible">{this.distanceBeetweenFields}</span>
                    <form id="ChangeUserPictureForm" onSubmit={this.handleUserPictureChangeSubmit}>
                        <h2>Change profile picture</h2>
                        <input
                            accept="image/*"
                            id="contained-button-file"
                            className="invisible"
                            multiple
                            type="file"
                            style={{ display: 'none' }}
                            ref={this.fileInput}
                        />
                        <label htmlFor="contained-button-file">
                            <Button variant="contained" component="span" >
                                Select
                            </Button>
                        </label>
                        <Button variant="contained" type="submit">submit</Button>
                        <p>{this.state.ChangePictureStatusText}</p>
                    </form>
                </div>
                {userSettings}
            </div>
        )
    }
}

export default UserProfile;